module.exports = __webpack_public_path__ + "static/OpenBSD httpd-efb05adf100fe3467381c801ef4805e6.svg";